export default __webpack_public_path__ + "static/media/32_mobile.277e813c.jpg";